module.exports = __webpack_public_path__ + "img/sempiternal.0a4d40fa.jpg";